import UISelect from 'UIComponents/input/UISelect';
import { EMAIL_CAMPAIGN } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { INPUT_WIDTHS_FOR_THREE_INPUTS_WITH_BULLET_POINT } from '../../constants/inlineLayout';
import { useConditionInputs } from '../../hooks/useConditionInputs';
import { useEditorActions } from '../../hooks/useEditorActions';
import { MEDIA_SIZES, useElementSize } from '../../hooks/useElementSize';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import { useMarketingEmailFilter } from '../../hooks/useMarketingEmailFilter';
import ConditionBox from '../common/ConditionBox';
import ConditionError from '../common/ConditionError';
import InlineContainerWithEditorConditionActions from '../common/InlineContainerWithEditorConditionActions';
import UpdateFilterWithExternalOptionsNotification from '../operator/UpdateFilterWithExternalOptionsNotification';
import EditorConditionAsset from './EditorConditionAsset';
import EditorConditionRefinementsContainer from './EditorConditionRefinementsContainer';
import EditorMarketingEmailRelatedConditionsGroup from './EditorMarketingEmailRelatedConditionsGroup';
//@ts-expect-error file not typed
import UITypeaheadResultsItem from 'UIComponents/typeahead/results/UITypeaheadResultsItem';
import EditorConditionValueInput from './EditorConditionValueInput';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorMarketingEmailRelatedConditionsGroupResponsive = props => {
  var _condition$field;
  const {
    condition,
    conditionPath
  } = props;
  const {
    width
  } = useElementSize();
  const {
    onConditionDelete
  } = useEditorActions();
  const {
    onFieldConditionFieldChange,
    onFieldConditionValueChange,
    onFieldConditionOperatorChange
  } = useFieldConditionChange(EMAIL_CAMPAIGN, conditionPath, condition);
  const {
    statusCondition,
    refinementConditionsEmptyValue,
    onStatusChange
  } = useMarketingEmailFilter(condition, onFieldConditionValueChange);

  //@ts-expect-error `userHasNoAccess` does not exist on `DSFieldRecordInstance`
  const userHasNoAccess = !!((_condition$field = condition.field) !== null && _condition$field !== void 0 && _condition$field.userHasNoAccess);
  const {
    canFilterBeConverted,
    disableOperatorSelection,
    disableValueInput,
    handleUpdateClick,
    isOperatorIncompatible,
    onSelectedOptionChange,
    operatorOptions
  } = useConditionInputs({
    condition: statusCondition,
    disabled: userHasNoAccess,
    filterFamily: EMAIL_CAMPAIGN,
    onConditionOperatorChange: onFieldConditionOperatorChange,
    onConditionValueChange: onStatusChange
  });
  if (width.size === MEDIA_SIZES.sm) {
    return /*#__PURE__*/_jsx(EditorMarketingEmailRelatedConditionsGroup, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsxs(ConditionBox, {
    children: [/*#__PURE__*/_jsxs(InlineContainerWithEditorConditionActions, {
      conditionPath: conditionPath,
      condition: condition,
      onConditionDelete: () => onConditionDelete(conditionPath),
      hideChangeFieldButton: true,
      isFilterBranch: true,
      filterFamily: EMAIL_CAMPAIGN,
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: INPUT_WIDTHS_FOR_THREE_INPUTS_WITH_BULLET_POINT[width.size]
        },
        children: /*#__PURE__*/_jsx(EditorConditionAsset, {
          condition: condition,
          filterFamily: EMAIL_CAMPAIGN,
          onAssetChange: onFieldConditionFieldChange
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          width: INPUT_WIDTHS_FOR_THREE_INPUTS_WITH_BULLET_POINT[width.size]
        },
        children: /*#__PURE__*/_jsx(UISelect, {
          "data-onboarding": "filter-condition-select-field",
          "data-selenium-test": "fr-filter-operator-select",
          "data-test-id": "fr-filter-operator-select",
          disabled: disableOperatorSelection,
          onSelectedOptionChange: onSelectedOptionChange,
          optionRenderer: option => /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
            message: true,
            option: option
          }),
          options: operatorOptions,
          readOnly: operatorOptions.length === 1,
          value: statusCondition.constructor.toString()
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          width: INPUT_WIDTHS_FOR_THREE_INPUTS_WITH_BULLET_POINT[width.size]
        },
        children: /*#__PURE__*/_jsx(EditorConditionValueInput, {
          condition: statusCondition,
          disabled: disableValueInput,
          filterFamily: EMAIL_CAMPAIGN,
          onChange: onStatusChange,
          size: "md"
        })
      })]
    }), isOperatorIncompatible && /*#__PURE__*/_jsx(UpdateFilterWithExternalOptionsNotification, {
      onUpdateClick: handleUpdateClick,
      canFilterBeConverted: canFilterBeConverted
    }), /*#__PURE__*/_jsx(ConditionError, {
      condition: condition
    }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: condition
    }), !userHasNoAccess && /*#__PURE__*/_jsx(EditorConditionRefinementsContainer, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: EMAIL_CAMPAIGN,
      onConditionChange: onFieldConditionValueChange,
      emptyRefinementConditions: refinementConditionsEmptyValue,
      hasInlineLayout: true
    })]
  });
};
export default EditorMarketingEmailRelatedConditionsGroupResponsive;